import { normalizeLocale, type SupportedLocale } from '@/i18n/config';
import { english } from './scheduled-page-copy-en';
import { scheduledPageCopyOverridesArRu } from './scheduled-page-copy-overrides-ar-ru';
import { scheduledPageCopyOverridesEastAsian } from './scheduled-page-copy-overrides-east-asian';
import { scheduledPageCopyOverridesIndicSea } from './scheduled-page-copy-overrides-indic-sea';
import { scheduledPageCopyOverridesWestern } from './scheduled-page-copy-overrides-western';
import { scheduledDetailedCopy } from './scheduled-page-copy-translations';
import type {
  ScheduledCopyOverride,
  ScheduledPageCopy,
} from './scheduled-page-copy-types';

export type { ScheduledPageCopy } from './scheduled-page-copy-types';

const localeOverrides: Record<SupportedLocale, ScheduledCopyOverride> = {
  en: {},
  ...scheduledPageCopyOverridesArRu,
  ...scheduledPageCopyOverridesEastAsian,
  ...scheduledPageCopyOverridesIndicSea,
  ...scheduledPageCopyOverridesWestern,
};

export function getScheduledPageCopy(locale: string): ScheduledPageCopy {
  const normalizedLocale = normalizeLocale(locale);
  const override = localeOverrides[normalizedLocale];
  const detailed =
    normalizedLocale === 'en'
      ? undefined
      : scheduledDetailedCopy[normalizedLocale];
  return {
    common: { ...english.common, ...override.common },
    header: { ...english.header, ...override.header },
    filters: { ...english.filters, ...override.filters },
    calendar: { ...english.calendar, ...override.calendar },
    status: { ...english.status, ...detailed?.status, ...override.status },
    editor: { ...english.editor, ...detailed?.editor, ...override.editor },
    detail: { ...english.detail, ...detailed?.detail, ...override.detail },
    notifications: {
      ...english.notifications,
      ...detailed?.notifications,
      ...override.notifications,
    },
    errors: { ...english.errors, ...detailed?.errors, ...override.errors },
  };
}

export function formatScheduledCopy(
  template: string,
  values: Readonly<Record<string, string | number>>
): string {
  return Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
    template
  );
}
